/**
 * A persisted patron request series should only be presented as recurring
 * while more than one booking remains. Removing later occurrences leaves the
 * series record (`recurrenceType` / `kind`) intact, so callers must not treat
 * that record alone as an active series.
 */
export const isActivePatronRequestSeries = ({
  hasSeriesRecurrence,
  remainingBookingCount,
}: {
  hasSeriesRecurrence: boolean;
  remainingBookingCount: number;
}) => hasSeriesRecurrence && remainingBookingCount > 1;
